export default __webpack_public_path__ + "static/media/nakul.6141cfa5.png";